export default __webpack_public_path__ + "static/media/R7SR157.e6bcb6ef.png";